import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import system from '../../../Constants/system';
import helpers from '../../../Utils/helpers';

export default function CompensationVbProducts({ products, onClick }) {
    const { t } = useTranslation();

    const validProducts = useMemo(() => {
        return products.filter(item => item.isProductValid);
    }, [products]);

    const handleProductClick = (item) => {
        const product = {
            product: item.productNumber,
            name: item.product,
            sourceSystem: system.Vb,
            users: item.additionalUsers,
            api: Boolean(item.api),
            period: null
        };
        onClick(product);
    };

    return <fieldset className="col-xs-12 vbProducts">
        <legend>{t('compensationvbproducts.onpremproducts')}</legend>
        <div className="table-container">
            <table className="table table-stripe table-hover">
                <thead>
                    <tr>
                        <th className="text-left">{t('compensationvbproducts.program')}</th>
                        <th className="text-left">{t('compensationvbproducts.purchasedate')}</th>
                        <th className="text-left">{t('compensationvbproducts.enddate')}</th>
                        <th className="text-left">{t('compensationvbproducts.users')}</th>
                        <th className="text-left">{t('compensationvbproducts.inactiveusers')}</th>
                        <th className="text-left">{t('compensationvbproducts.api')}</th>
                    </tr>
                </thead>
                <tbody>
                    {validProducts.map((product) => {
                        return <tr key={product.productNumber} onClick={() => handleProductClick(product)}>
                            <td className="text-left">{product.product}</td>
                            <td className="text-left">{helpers.formatDate(product.purchaseDate)}</td>
                            <td className="text-left">{helpers.formatDate(product.endDate)}</td>
                            <td className="text-left">{product.users}</td>
                            <td className="text-left">{product.inactiveUsers}</td>
                            <td className="text-left">{product.api}</td>
                        </tr>
                    })
                    }
                </tbody>
            </table>
        </div>
    </fieldset>
}